export const WELCOME_MESSAGE = {
  "message": "Welcome to PSOPPC! I am an AI chatbot designed to answer any questions related to PSOPPC! How can I assist you today?",
  "session_id": "",
  "chatId": 0,
  "documents": [],
  "webpages": [],
  "reset_memory": false,
  "timestamp": ""
};

// build timestamp for message: month day, hour:minute with AM/PM
export const buildTimestamp = () => {
  const now = new Date();
  const month = now.toLocaleString('default', { month: 'short' });
  const day = now.getDate();
  let hour = now.getHours();
  const minute = now.getMinutes().toString().padStart(2, '0');
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  hour = hour ? hour : 12;

  return `${month} ${day}, ${hour}:${minute} ${ampm}`;
}
